import { useMutation } from "react-query";
import { updateOwners } from "~/components/Forms/DealerPassportForm2/requests/updateOwners";

export default function useUpdateOwners() {
  return useMutation({
    mutationFn: ({ dealerId, data }: { dealerId: string; data: any }) =>
      updateOwners(dealerId, data),
  });
}
